module.exports = ".clientDetailMail span {\r\n    width: 99%;\r\n}\r\n\r\n#bounced_mails_textarea {\r\n    resize: none;\r\n    height: 200px;\r\n    width: 100%;\r\n    white-space: pre-wrap;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/clinic/broadcast/modal-broadcast-mail-failed.css
// module id = ./src/app/app_manager/modal/clinic/broadcast/modal-broadcast-mail-failed.css
// module chunks = main